require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-mobile-point-of-sale-devices-we-compare-izettle-sumup-paypal-here-and-shopify-pos.json") })
        }
      }, "path---blog-mobile-point-of-sale-devices-we-compare-izettle-sumup-paypal-here-and-shopify-pos");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-mobile-point-of-sale-devices-we-compare-izettle-sumup-paypal-here-and-shopify-pos!./.cache/json/blog-mobile-point-of-sale-devices-we-compare-izettle-sumup-paypal-here-and-shopify-pos.json
// module id = 477
// module chunks = 231608221292675